<!-- <p>rapid-schedule-visitor works!</p> -->
<div
  [ngClass]="{
    'mat-dialog-header':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'mat-dialog-header-mobile': screenSize == ScreenType.Mobile
  }"
>
  <h1 mat-dialog-title>
    Rapid Visitor Schedule
    <button mat-mini-fab mat-dialog-close cdkFocusInitial>
      <mat-icon>clear</mat-icon>
    </button>
  </h1>
</div>
<mat-dialog-content class="mat-typography">
  <div class="tickets-dialog-options">
    <form [formGroup]="rapidScheduleVisitor" style="width: 100%">
      <div class="form-fields-container">
        <div class="form-field-updates">
          <div
            *ngIf="!isUniqueVisitor && isValid"
            class="warn-banner"
            [ngStyle]="
              screenSize != ScreenType.Mobile
                ? { 'font-size': '14px' }
                : screenSize == ScreenType.Mobile
                ? { 'font-size': '12px' }
                : {}
            "
          >
            <div class="warn-banner-text">
              {{ phoneForm.get("phone").value }} already exists, Please
              re-schedule!
            </div>
            <button (click)="onEditDetails()" mat-raised-button>
              Edit Record
            </button>
            <div
              *ngIf="!isUniqueVisitor && isValid"
              class="searched-image-container"
            >
              <img [src]="searchedImage" alt="Searched Image" />
            </div>
          </div>

          <div
            *ngIf="!isUniqueVisitor && !isValid && !isManuallyCheck"
            class="error-banner"
            [ngStyle]="
              screenSize != ScreenType.Mobile
                ? { 'font-size': '16px' }
                : screenSize == ScreenType.Mobile
                ? { 'font-size': '14px' }
                : {}
            "
          >
            <div class="prompt-message">
              {{ phoneForm.get("phone").value }} not yet checked-out!
            </div>
            <button (click)="onManualCheckVisitor()" mat-raised-button>
              Check-Out
            </button>
          </div>
          <div
            *ngIf="!isUniqueVisitor && !isValid && isManuallyCheck"
            class="warn-banner"
            [ngStyle]="
              screenSize != ScreenType.Mobile
                ? { 'font-size': '16px' }
                : screenSize == ScreenType.Mobile
                ? { 'font-size': '14px' }
                : {}
            "
          >
            <div class="prompt-message">
              {{ phoneForm.get("phone").value }} been manually checked-out!
            </div>
            <button (click)="onEditDetails()" mat-raised-button>
              Edit Record
            </button>
          </div>
        </div>
        <form class="phone-form-field" #f="ngForm" [formGroup]="phoneForm">
          <mat-form-field
            class="no-padding-mat-form-field"
            appearance="outline"
            subscriptSizing="dynamic"
            style="margin-bottom: 10px"
          >
            <ngx-mat-intl-tel-input
              #phoneInput
              [enablePlaceholder]="true"
              [required]="true"
              [preferredCountries]="['in']"
              [enableSearch]="true"
              name="phone"
              formControlName="phone"
              [inputPlaceholder]="'Phone Number*'"
              [label]="'Phone Number'"
              [maxlength]="15"
              (change)="onChangeNumber($event)"
            ></ngx-mat-intl-tel-input>
            <mat-error
              *ngIf="f.form.controls['phone']?.errors?.['validatePhoneNumber']"
              ><i>Enter valid number</i>
            </mat-error>
          </mat-form-field>
        </form>
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          style="margin-bottom: 10px"
        >
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName" />
        </mat-form-field>
        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          style="margin-bottom: 10px"
        >
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName" />
        </mat-form-field>
        <!-- <mat-form-field appearance="outline">
          <mat-label>Phone Number</mat-label>
          <input
            (keypress)="inputValidator($event)"
            matInput
            formControlName="phoneNumber"
            maxlength="10"
          />
        </mat-form-field> -->

        <mat-form-field
          appearance="outline"
          subscriptSizing="dynamic"
          style="margin-bottom: 10px"
          ><mat-label>Visit Date</mat-label>
          <input
            matInput
            [readonly]="true"
            [matDatepicker]="startDatePicker"
            formControlName="visitDateTime"
            [min]="minDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
        <div class="pass-validity-wrapper" style="margin-bottom: 10px">
          <div class="checkbox-container">
            <mat-checkbox
              [disabled]="
                rapidScheduleVisitor.controls.firstName.disabled ||
                !rapidScheduleVisitor.get('visitDateTime')?.value
              "
              [checked]="isEnabled"
              (change)="
                isEnabled
                  ? rapidScheduleVisitor.get('ePassValidity')?.disable()
                  : rapidScheduleVisitor.get('ePassValidity')?.enable();
                isEnabled = !isEnabled
              "
            ></mat-checkbox>
          </div>
          <mat-form-field
            subscriptSizing="dynamic"
            appearance="outline"
            class="invite-form-fields"
          >
            <mat-label>Pass Validity </mat-label>
            <input
              matInput
              readonly
              formControlName="ePassValidity"
              [matDatepicker]="Datepicker"
              [min]="minPassValidityDate"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="Datepicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #Datepicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="checkbox-container">
          <mat-checkbox
            formControlName="sendQR"
            [checked]="isChecked"
            (change)="onCheckboxChange()"
            >Send QR</mat-checkbox
          >
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    *ngIf="!(!isUniqueVisitor && !isValid)"
    [disabled]="rapidScheduleVisitor.invalid || !isEnable"
    mat-raised-button
    (click)="onSubmit()"
  >
    {{
      rapidScheduleVisitor.controls.isReVisit.value ? "Re-Schedule" : "Schedule"
    }}
  </button>
  <!-- <button *ngIf="!isUniqueVisitor && !isValid" mat-raised-button>
    Checkout and reschedule
  </button> -->
</mat-dialog-actions>
